export enum SlideTransitionType {
  'FROM_RIGHT' = 'FROM_RIGHT',
  'FROM_BOTTOM' = 'FROM_BOTTOM',
}
